import { createContext } from 'react';
/**
 * A context for preferences related configuration.
 */
export var PreferencesContext = createContext(undefined);
